import HTTP from './http.config';
import { formatOrgIds } from './utils';

const allForms = () => HTTP.get('/allforms');

const getForm = (urlFormId) => HTTP.get(`/${urlFormId}`);

const createForm = (data) => HTTP.post('/createform', data);

const loggedInUser = () => HTTP.get('/loggedinuser');

const copyForm = (urlFormId, body) => HTTP.post(`/copy/${urlFormId}`, body);

const deleteForm = (urlFormId) => HTTP.delete(`/delete/${urlFormId}`);

const saveFormSettings = (data, urlFormId) => HTTP.patch(`/${urlFormId}`, data);

const saveForm = (data) => HTTP.patch(`/${data.urlFormId}`, data);

const getParam = (surveyId, organizationId) => {
    if ((surveyId > 0) && (organizationId >= 0))
        return { params: { surveyId: surveyId, organizationId: organizationId } };
    if (surveyId > 0)
        return { params: { surveyId: surveyId } };
    if (organizationId >= 0)
        return { params: { organizationId: organizationId } };
    return null;
}

const getFormResponses = (urlFormId, surveyId, organizationId) => {
    return HTTP.get(`/data/${urlFormId}`, getParam(surveyId, organizationId));
}

const getAggregatedResponses = (urlFormId, surveyId, organizationId) => {
    return HTTP.get(`/data/${urlFormId}/aggregate`, getParam(surveyId, organizationId));
}

const getDashboardReport = (urlFormId) => HTTP.get(`/${urlFormId}/report`);

const getFormAndSurvey = (urlFormId, surveyId) => {
    return Promise.all([HTTP.get(`/${urlFormId}`), HTTP.get(`/${urlFormId}/surveys/${surveyId}`)]);
}

export default {
    allForms,
    getForm,
    getFormAndSurvey,
    getFormResponses,
    getAggregatedResponses,
    getDashboardReport,
    createForm,
    loggedInUser,
    deleteForm,
    saveForm,
    saveFormSettings,
    copyForm
};
